/* eslint-disable @stylistic/max-len */
import {
  GOOGLE_ADS_SLOT_TYPE_OUT_OF_PAGE,
  GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
} from '@sgcmpteltd/uikit-next/components/google-ads';
import type { GoogleAdsConfig } from '@sgcmpteltd/uikit-next/types';

export const newCarLandingLeaderboard: GoogleAdsConfig = {
  adUnitPath: '/1707400/SGCM_NewCars_Landing_Leaderboard',
  divId: 'div-gpt-ad-1667447830750-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
    size: [[970, 90], [728, 90], [1920, 400]],
  },
  targetingMap: {
    pageType: 'new-cars',
  },
};

export const newCarLandingFeaturedSpots: GoogleAdsConfig[] = [
  {
    adUnitPath:
    '/1707400/sgcm_new_car_featured_spot/SGCM_New_Car_Featured_Spot-1_Desktop',
    divId: 'div-gpt-ad-1667977034204-0',
    slot: {
      type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
      size: [300, 250],
    },
  },
  {
    adUnitPath:
    '/1707400/sgcm_new_car_featured_spot/SGCM_New_Car_Featured_Spot-2_Desktop',
    divId: 'div-gpt-ad-1667977049659-0',
    slot: {
      type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
      size: [300, 250],
    },
  },
  {
    adUnitPath:
    '/1707400/sgcm_new_car_featured_spot/SGCM_New_Car_Featured_Spot-3_Desktop',
    divId: 'div-gpt-ad-1667977062876-0',
    slot: {
      type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
      size: [300, 250],
    },
  },
  {
    adUnitPath:
    '/1707400/sgcm_new_car_featured_spot/SGCM_New_Car_Featured_Spot-4_Desktop',
    divId: 'div-gpt-ad-1667977076195-0',
    slot: {
      type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
      size: [300, 250],
    },
  },
  {
    adUnitPath:
    '/1707400/sgcm_new_car_featured_spot/SGCM_New_Car_Featured_Spot-5_Desktop',
    divId: 'div-gpt-ad-1667977091156-0',
    slot: {
      type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
      size: [300, 250],
    },
  },
  {
    adUnitPath:
    '/1707400/sgcm_new_car_featured_spot/SGCM_New_Car_Featured_Spot-6_Desktop',
    divId: 'div-gpt-ad-1667977105812-0',
    slot: {
      type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
      size: [300, 250],
    },
  },
];

export const newCarInfoFeaturedMerchants: GoogleAdsConfig[] = [
  {
    adUnitPath: '/1707400/sgcm_newcar_merchant_featuredspot/SGCM_NewCar_Merchant_FeaturedSpot_1',
    divId: 'div-gpt-ad-1667963279379-0',
    slot: {
      type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
      size: [180, 120],
    },
  },
  {
    adUnitPath: '/1707400/sgcm_newcar_merchant_featuredspot/SGCM_NewCar_Merchant_FeaturedSpot_2',
    divId: 'div-gpt-ad-1667963235291-0',
    slot: {
      type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
      size: [180, 120],
    },
  },
  {
    adUnitPath: '/1707400/sgcm_newcar_merchant_featuredspot/SGCM_NewCar_Merchant_FeaturedSpot_3',
    divId: 'div-gpt-ad-1667963242543-0',
    slot: {
      type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
      size: [180, 120],
    },
  },
  {
    adUnitPath: '/1707400/sgcm_newcar_merchant_featuredspot/SGCM_NewCar_Merchant_FeaturedSpot_4',
    divId: 'div-gpt-ad-1667963279319-0',
    slot: {
      type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
      size: [180, 120],
    },
  },
  {
    adUnitPath: '/1707400/sgcm_newcar_merchant_featuredspot/SGCM_NewCar_Merchant_FeaturedSpot_5',
    divId: 'div-gpt-ad-1667963272643-0',
    slot: {
      type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
      size: [180, 120],
    },
  },
  {
    adUnitPath: '/1707400/sgcm_newcar_merchant_featuredspot/SGCM_NewCar_Merchant_FeaturedSpot_6',
    divId: 'div-gpt-ad-1667963274669-0',
    slot: {
      type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
      size: [180, 120],
    },
  },
  {
    adUnitPath: '/1707400/sgcm_newcar_merchant_featuredspot/SGCM_NewCar_Merchant_FeaturedSpot_7',
    divId: 'div-gpt-ad-1667963279134-0',
    slot: {
      type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
      size: [180, 120],
    },
  },
  {
    adUnitPath: '/1707400/sgcm_newcar_merchant_featuredspot/SGCM_NewCar_Merchant_FeaturedSpot_8',
    divId: 'div-gpt-ad-1667963271344-0',
    slot: {
      type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
      size: [180, 120],
    },
  },
];

export const newCarListingLeaderboard: GoogleAdsConfig = {
  adUnitPath: '/1707400/SGCM_NewCars_Listing_Leaderboard',
  divId: 'div-gpt-ad-1667447861607-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
    size: [[970, 90], [728, 90], [970, 250], [1920, 400]],
  },
};

export const newCarPromotion: GoogleAdsConfig = {
  adUnitPath: '/1707400/SGCM_TA_PopUp',
  divId: 'div-gpt-ad-1707986064426-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
    size: [700, 394],
  },
};

export const newCarCompetitorPromotion: GoogleAdsConfig = {
  adUnitPath: '/1707400/SGCM_TA_Competitor_PopUp',
  divId: 'div-gpt-ad-1707985957319-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
    size: [700, 394],
  },
};

export const newCarInfoLeaderboard: GoogleAdsConfig = {
  adUnitPath: '/1707400/SGCM_NewCars_ROS_Leaderboard',
  divId: 'div-gpt-ad-1667454714442-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
    size: [[970, 90], [728, 90]],
  },
};

export const ptoTrigger: GoogleAdsConfig = {
  adUnitPath: '/1707400/SGCM_Home_PTO_Trigger',
  divId: 'div-gpt-ad-1591155939877-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_OUT_OF_PAGE,
  },
};

export const ptoPopup: GoogleAdsConfig = {
  adUnitPath: '/1707400/SGCM_Home_PTO_Popup',
  divId: 'div-gpt-ad-1591156066988-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
    size: [800, 500],
  },
};

export const catfishInterstitial: GoogleAdsConfig = {
  adUnitPath: '/1707400/SGCM_NewCar_Catfish_Desktop',
  divId: 'div-gpt-ad-1601818098210-1',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_OUT_OF_PAGE,
  },
};
export const catfishTestHome: GoogleAdsConfig = {
  adUnitPath: '/1707400/Test_SGCM_Home_Catfish_Desktop',
  divId: 'div-gpt-ad-1694590491604-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_OUT_OF_PAGE,
  },
};
